export const translationLivechat_sv_part1 = {
  livechatDefaultSupportAgent: "Supportagent",
  livechatPageTitle: "Livechat",
  livechatWorkspaceEyebrow: "Livechat-arbetsyta",
  livechatWorkspaceTitle: "Hantera hela livechat-livscykeln från instrumentpanelen",
  livechatWorkspaceSubtitle:
    "Arbeta med väntekön, gå med i konversationer, svara med bilagor, hantera din agentprofil och stäng sessioner utan att lämna instrumentpanelen.",
  livechatStatusWaiting: "Väntar",
  livechatNotificationOsTitle: "Livechat",
  livechatNotificationOsBody: "Ny livechat-aktivitet väntar på dig.",
  livechatConnectionLost:
    "Livuppdateringar är frånkopplade. Nya chattar och notifikationer kanske inte visas förrän anslutningen återställs.",
  livechatConnectionLostRetry: "Försök igen",
  livechatOsNotificationsOff:
    "Webbläsarnotifikationer är avstängda — du aviseras inte om nya chattar medan den här fliken inte är fokuserad.",
  livechatOsNotificationsEnable: "Aktivera notifikationer",
  livechatOsNotificationsBlocked:
    "Notifikationer är blockerade av din webbläsare. Tillåt notifikationer för den här webbplatsen i webbläsarinställningarna för att aviseras om nya chattar.",
  livechatWaitingNotificationAriaSingular: "Väntar, 1 väntande session",
  livechatWaitingNotificationAriaPlural: "Väntar, {count} väntande sessioner",
  livechatOurTurnNotificationAriaSingular: "{label}, 1 aktiv konversation behöver ditt svar",
  livechatOurTurnNotificationAriaPlural: "{label}, {count} aktiva konversationer behöver ditt svar",
  livechatStatusActive: "Aktiv",
  livechatStatusClosed: "Stängd",
  livechatTurnFilterAll: "Alla",
  livechatTurnFilterOurTurn: "Vår tur",
  livechatTurnFilterTheirTurn: "Deras tur",
  livechatEnvLive: "Live",
  livechatEnvTest: "Test",
  livechatBadgeLiveMode: "LIVELÄGE",
  livechatBannerLiveTitle: "Live-kundarbetsyta",
  livechatBannerLiveDescription:
    "Sessioner, webhooks, agentprofil och inställningar på den här sidan påverkar live-trafik.",
  livechatBadgeTestMode: "TESTLÄGE",
  livechatBannerTestTitle: "Sandbox livechat-arbetsyta",
  livechatBannerTestDescription:
    "Sessioner, webhooks, agentprofil och inställningar på den här sidan är isolerade till testläge.",
  livechatIndicatorTooltipOffline: "Livechat är offline för besökare. {reason}",
  livechatIndicatorAriaOffline: "Livechat offline för besökare. {reason}",
  livechatIndicatorLoading: "Laddar livechat-tillgänglighet…",
  livechatIndicatorNoChatbot: "Välj en chatbot för att se tillgänglighet.",
  livechatFilterChatbotLabel: "Chatbot",
  livechatFilterAllChatbots: "Alla chatbotar",
  livechatFilterMultipleChatbots: "{count} chatbotar",
  livechatCannedResponsesTitle: "Sparade svar",
  livechatCannedResponsesBack: "Tillbaka till livechat",
  livechatCannedResponsesDescription:
    "Skapa sparade svar som agenter kan infoga i livechat med en knapp eller snedstreck-kommando.",
  livechatCannedResponsesAdd: "Lägg till sparat svar",
  livechatCannedResponsesCreateFolder: "Skapa mapp",
  livechatCannedResponsesChatbotLabel: "Chatbot",
  livechatCannedResponsesFolderNameLabel: "Mappnamn",
  livechatCannedResponsesFolderNamePlaceholder: "T.ex. Reklamationer",
  livechatCannedResponsesFolderSave: "Spara mapp",
  livechatCannedResponsesFolderNameRequired: "Mappnamn krävs.",
  livechatCannedResponsesFolderSaveFailed: "Det gick inte att spara mappen.",
  livechatCannedResponsesFolderDeleteFailed: "Det gick inte att ta bort mappen.",
  livechatCannedResponsesFolderLabel: "Mapp",
  livechatCannedResponsesFolderScopeHint:
    "Mappar är per chatbot. Välj bara {chatbotId} för att placera det här svaret i en mapp.",
  livechatCannedResponsesNoFolder: "Ingen mapp",
  livechatCannedResponsesFolderEmpty: "Dra sparade svar hit för att lagra dem i den här mappen.",
  livechatCannedResponsesFolderExpand: "Expandera",
  livechatCannedResponsesFolderCollapse: "Minimera",
  livechatCannedResponsesDragHint: "Dra för att flytta till en mapp",
  livechatCannedResponsesMoveFailed: "Det gick inte att flytta det sparade svaret.",
  livechatCannedResponsesCommandLabel: "Kommando",
  livechatCannedResponsesTitleLabel: "Titel",
  livechatCannedResponsesBodyLabel: "Svartext",
  livechatCannedResponsesScopeLabel: "Tillgänglig på",
  livechatCannedResponsesScopeHelp:
    "Välj vilka chatbotar det här sparade svaret ska vara tillgängligt för.",
  livechatCannedResponsesScopeAll: "Alla chatbotar",
  livechatCannedResponsesEditScopeNotice: "Ändringar gäller för alla {count} valda chatbotar.",
  livechatCannedResponsesTitlePlaceholder: "T.ex. Uppföljning klagomål",
  livechatCannedResponsesBodyPlaceholder: "Skriv svaret som ska infogas i chatten...",
  livechatCannedResponsesSave: "Spara sparat svar",
  livechatCannedResponsesSaving: "Sparar...",
  livechatCannedResponsesLoading: "Laddar sparade svar...",
  livechatCannedResponsesEmpty: "Inga sparade svar har skapats för den här chatboten ännu.",
  livechatCannedResponsesNoMatches: "Inga sparade svar matchar ditt snedstreck-kommando.",
  livechatCannedResponsesLoadFailed: "Det gick inte att ladda sparade svar.",
  livechatCannedResponsesSaveFailed: "Det gick inte att spara det sparade svaret.",
  livechatCannedResponsesDeleteFailed: "Det gick inte att ta bort det sparade svaret.",
  livechatCannedResponsesDeleteConfirmTitle: "Ta bort sparat svar?",
  livechatCannedResponsesDeleteConfirmDescription:
    "Detta tar bort {command} från {chatbotCount} {chatbotLabel}: {chatbots}.",
  livechatCannedResponsesFormRequired: "Kommando, titel och svartext krävs.",
  livechatCannedResponsesInsert: "Infoga",
  livechatCannedResponsesKeyboardHint: "↑↓ navigera · Enter infoga · Esc stäng",
  livechatEdit: "Redigera",
  livechatDelete: "Ta bort",
  livechatAgentProfileSet: "Ange profil",
  livechatAgentProfile: "Agentprofil",
  livechatSettingsAriaLabel: "Livechat-inställningar",
  livechatSettingsTitleAttr: "Livechat-inställningar",
  livechatBackToConversation: "Tillbaka till konversation",
  livechatVisitorSessions: "Besökarsessioner",
  livechatNoTimestamp: "Ingen tidsstämpel",
  livechatAriaOpenSession: "Öppna {status} livechat-session {sessionId}",
  livechatJustNow: "Just nu",
  livechatUnknown: "Okänd",
  livechatSessionsEmptyFilters: "Inga livechat-sessioner matchar de aktuella filtren.",
  livechatLoadingMoreSessions: "Laddar fler sessioner...",
  livechatEndOfList: "Slut på listan",
  livechatTurnOurTurn: "Vår tur",
  livechatTurnTheirTurn: "Deras tur",
  livechatVisitorLabel: "Besökare",
  livechatCustomerTyping: "Kunden skriver",
  livechatAgentTyping: "Agenten skriver",
  livechatAssignedTo: "Tilldelad till",
  livechatUnassigned: "Otilldelad",
  livechatEnvLiveLower: "live",
  livechatEnvTestLower: "test",
  livechatSessionStatusWaiting: "väntar",
  livechatSessionStatusActive: "aktiv",
  livechatSessionStatusClosed: "stängd",
  livechatActiveTurnFilterAria: "Aktivt livechat-turfilter",
  livechatSelectChatbotBeforeSettings: "Välj en chatbot innan du ändrar livechat-inställningar.",
  livechatFailedSaveProfile: "Det gick inte att spara livechat-profilen.",
  livechatFailedJoinSession: "Det gick inte att gå med i livechat-sessionen.",
  livechatFailedSendReply: "Det gick inte att skicka livechat-svaret.",
  livechatFailedTakeoverProviderControl: "Det gick inte att ta över livechat-sessionen.",
};
